import { render, staticRenderFns } from "./StaffDetailsPage.vue?vue&type=template&id=1f6d76ea&scoped=true&"
import script from "./StaffDetailsPage.vue?vue&type=script&lang=js&"
export * from "./StaffDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetailsPage.vue?vue&type=style&index=0&id=1f6d76ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6d76ea",
  null
  
)

export default component.exports